import React from 'react';

export interface AppInfo {
  keyword: string;
  aliases?: string[];
}

export const getAppBadge = (content: string | undefined, apps: AppInfo[]): string | null => {
  if (!content || apps.length === 0) return null;
  const firstWord = content.trim().split(/\s+/)[0];
  if (!firstWord) return null;
  const upper = firstWord.toUpperCase();
  const matched = apps.some(
    app =>
      app.keyword?.toUpperCase() === upper ||
      (app.aliases || []).some(alias => alias.toUpperCase() === upper)
  );
  return matched ? upper : null;
};

export const AppBadge: React.FC<{ label: string }> = ({ label }) => (
  <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
    {label}
  </span>
);
